import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bodyIsFixed: false,
};
const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    makeBodyFixed(state, action) {
      state.bodyIsFixed = action.payload.bodyIsFixed;
    },
  },
});

export const appActions = appSlice.actions;

export default appSlice.reducer;
